export default function reportTypesDirective() {
  return {
    template: require('./report-types.html'),
    controller: 'MRReportTypesController',
    controllerAs: 'mrReportTypesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportTypes: '=',
    },
  };
}
